// Path: poc/app/src/services/api.js

export const getDataSource = () => {
  if (process.env.NODE_ENV === "development") {
    return "./data";
  } else {
    return `${window.location.origin}/elections/data`;
  }
};

export const fetchCommuneData = (communeId) => {
  let url = `${getDataSource()}/communes/${communeId}-commune.json`;
  return fetch(url).then((response) => response.json());
};

// Fetches candidate data from a JSON file
export const fetchCandidateData = (lang) => {
  // let url = `${window.location.origin}/elections/data/candidates/${lang}.json`;
  let url = `${getDataSource()}/candidates/${lang}.json`;
  return fetch(url).then((response) => response.json());
};

export const fetchResultsData = (communeId, year) => {
  let url = `${getDataSource()}/results/${year}/${communeId}.json`;
  return fetch(url).then((response) => response.json());
};

// Fetches articles data from a JSON file
export const fetchArticlesData = (lang) => {
  let url = `${getDataSource()}/articles/${lang}.json`;
  return fetch(url).then((response) => response.json());
};
